import React from "react";
import { Link } from "react-router-dom";
import TooltipMenu from "../../components/ui/tooltipmenu/TooltipMenu";
import OrderTrackerList from "./components/orderTrackerList/OrderTrackerList";

import classes from "./OrderTracker.module.css";

const OrderTracker = (props) => {
  return (
    <TooltipMenu onClose={props.onClick}>
      <div className="my-order-show">
       
        <OrderTrackerList />
        <div className={classes["track-title"]}>Track my order</div>
        <form className="track-order-form" id="topActionTrackForm">
          <label
            htmlFor="topActionTrackOrderNumber"
            className={classes["top-input-label"]}
          >
            Your order number:
          </label>
          <div
            className={`${classes["top-input-wrap"]} ${classes["track-order-input-wrap"]}`}
          >
            <input
              placeholder="eg.123456789"
              id="topActionTrackOrderNumber"
              className={classes["order-text"]}
            />
            <button type="button" className={classes["button-submit"]}>
              <ion-icon name="chevron-forward-outline"></ion-icon>
            </button>
          </div>
          <p className={classes["track-order-more-text"]}>
            For any other inquiries,
            <Link to="#" title="For any other inquiries, ">
              Click here
            </Link>
          </p>
        </form>
      </div>
    </TooltipMenu>
  );
};

export default OrderTracker;
